export const ALZURA_HEADER_HEIGHT_VAR = '--alzura-header-height';

export function setAlzuraHeaderHeight(height) {
  document.documentElement.style.setProperty(ALZURA_HEADER_HEIGHT_VAR, `${height}px`);
}
